const isMspProduct = () =>
  window.location.pathname.split("/")[1].includes("msp");

const redirectToContactPage = () => {
  const contactUsPage = window.open("https://zecurit.com/contact/", "_blank");

  if (contactUsPage) {
    contactUsPage.focus();
  }
};
export { isMspProduct, redirectToContactPage };
